import { sortBy, uniqueBy } from 'lib/array/arrayUtils'
import { formatCountryName } from 'lib/format/formatRegionName'

export interface FlightDealDestinationFilter {
  label: string
  value: string
  price: number
}

export function getFlightDealDestinationFilters(
  deals: Array<App.FlightDeal>,
  selectedAirlines: Set<string>,
  selectedCabins: Set<string>,
  locale: string,
  allKey: string,
): Array<FlightDealDestinationFilter> {
  const countries = deals.filter(deal => {
    const airlineIncluded = selectedAirlines.has(allKey) || selectedAirlines.has(deal.carrier.code)
    const cabinIncluded = selectedCabins.has(allKey) || selectedCabins.has(deal.fareClass)
    return airlineIncluded && cabinIncluded
  }).map(deal => ({
    label: formatCountryName(deal.destinationCountry, locale),
    value: deal.destinationCountry,
    price: deal.perAdultPrice,
  }))

  const sortedCountries = sortBy(countries, (country) => country.price, 'asc')
  return uniqueBy(sortedCountries, country => country.value)
}
